
import React from 'react';
import { Grid, TextField, Button, Typography, withStyles, CircularProgress } from '@material-ui/core';
import { useDispatch, useSelector } from "react-redux";
import { searchPax, changeInput, searchPnr } from '../../store/paxSearch';
import Search from '@material-ui/icons/Search';
import styles from './styles';

function SearchForm(props) {
  const { classes, loading } = props;
  const dispatch = useDispatch();
  
  const lastName = useSelector(state => state.entities.paxSearch.lastName);
  const firstName = useSelector(state => state.entities.paxSearch.firstName);
  const date = useSelector(state => state.entities.paxSearch.date);
  const pnr = useSelector(state => state.entities.paxSearch.pnr);
  
  const handleInputChange = (change, type) => {
    dispatch(changeInput({type, data: change}));
  }
  
  const handleSubmit = () => {
    // Defaulting name search over pnr search
    lastName ? 
      dispatch(searchPax({lastName, firstName, date})) :
      dispatch(searchPnr(pnr));
  }
  
  return (
    <Grid container>
      <Grid item xs={12} md={8} className={classes.resultPageInputs}>
        <Grid container>
          <Grid item xs={6} md={4}>
            <TextField 
              label="Last Name" 
              variant="outlined" 
              value={lastName}
              onChange={(e) => {handleInputChange(e.target.value, "lastName")}}
              fullWidth 
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <TextField 
              label="First Name (Optional)" 
              value={firstName}
              onChange={(e) => {handleInputChange(e.target.value, "firstName")}}
              variant="outlined" 
              fullWidth 
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <TextField 
              type="date"
              value={date}
              onChange={(e) => {handleInputChange(e.target.value, "date")}}
              variant="outlined" 
              fullWidth 
            />
          </Grid>
        </Grid>

      </Grid>
      <Grid item xs={12} md={1} className={classes.centered}>
        <Typography>Or</Typography>
      </Grid>
      <Grid item xs={6} md={2}>
        <TextField 
          label="PNR" 
          variant="outlined" 
          value={pnr}
          fullWidth 
          // disabled={true} 
          onChange={(e) => {handleInputChange(e.target.value, "pnr")}}
        />
      </Grid>
      <Grid item xs={6} md={1} className={classes.searchBtn}>
        <Button
          variant="contained"
          color="primary"
          disabled={loading}
          onClick={handleSubmit}
        >
          {loading ? <CircularProgress color="inherit" /> : <Search />}
        </Button>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(SearchForm);